import React, { type ReactNode, type PropsWithChildren } from 'react';

export default class ErrorBoundary extends React.Component {
    state: { hasError: boolean; };

    constructor(public props: PropsWithChildren<{ fallback: ReactNode; }>) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: unknown) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.fallback;
        }

        return this.props.children;
    }
}